const baseURL = 'https://donalitas.com/';

export default baseURL;
